import { getCloudPACSToken } from "@custom/Utils/authUtils";
import { _PacsEditTagsUrls } from "@custom/Utils/constants/apiUrls";
import { ApiResponse, PatientTagsProps, SeriesTagsProps, StudyTagsProps } from "@custom/Utils/constants/interfaces";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const updateTagsApi = {
    fetchPatientTags: createAsyncThunk(
        "patientTags/update",
        async (props: PatientTagsProps, { rejectWithValue }) => {
            const pacs_token = getCloudPACSToken();
            try {
                const response = await fetch(
                    _PacsEditTagsUrls.editPatientTags(props.patientID, props.patientIdentifier),
                    {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${pacs_token}`,
                        },
                        body: JSON.stringify(props.changedTagsPatient),
                    }
                );

                if (!response.ok) {
                    throw new Error('Failed to update patient tags');
                }

                const data: ApiResponse<any> = await response.json();
                return data;
            } catch (error) {
                return rejectWithValue(error);
            }
        }
    ),

    fetchStudyTags: createAsyncThunk(
        "studyTags/update",
        async (props: StudyTagsProps, { rejectWithValue }) => {
            const pacs_token = getCloudPACSToken();
            try {
                const response = await fetch(
                    _PacsEditTagsUrls.editStudyTags(props.studyInstanceUID),
                    {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${pacs_token}`,
                        },
                        body: JSON.stringify(props.changedTagsStudy),
                    }
                );

                if (!response.ok) {
                    throw new Error('Failed to update study tags');
                }

                const data: ApiResponse<any> = await response.json();
                return data;
            } catch (error) {
                return rejectWithValue(error);
            }
        }
    ),

    fetchSeriesTags: createAsyncThunk(
        "seriesTags/update",
        async (props: SeriesTagsProps, { rejectWithValue }) => {
            const pacs_token = getCloudPACSToken();
            try {
                const response = await fetch(
                    _PacsEditTagsUrls.editSeriesTags(props.studyInstanceUID, props.seriesInstanceUID),
                    {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${pacs_token}`,
                        },
                        body: JSON.stringify(props.changedTagsSeries),
                    }
                );

                if (!response.ok) {
                    throw new Error('Failed to update series tags');
                }

                const data: ApiResponse<any> = await response.json();
                return data;
            } catch (error) {
                return rejectWithValue(error);
            }
        }
    )
};
